import React from "react";
import Box from "@mui/material/Box";
import { CompanyLogo } from "@/components/companyLogo";
import RecaptchaTerms from "@/components/recaptchaTerms";
import { Typography } from "@mui/material";

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight="100vh"
      bgcolor={{ xs: "transparent", sm: "#f8f8f8" }}
    >
      <Box
        textAlign="center"
        boxShadow={{ xs: 0, sm: 3 }}
        borderRadius={{ xs: 0, sm: 2 }}
        p={2}
        px={6}
        width="fullWidth"
        bgcolor="white"
        sx={{ overflowY: "auto" }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems={"center"}
          flexDirection={"column"}
          mb={2}
          mt={2}
        >
          <CompanyLogo style={{ maxWidth: "240px", maxHeight: "240px" }} />
          <Typography variant="body1" fontStyle={"italic"}>
            powered by
          </Typography>
          <img
            src="/images/primaryrewardst.png"
            style={{
              width: "270px",
              height: "175px",
              objectFit: "cover",
              objectPosition: "center 88%",
              marginTop: "-16px",
              marginBottom: "-16px",
            }}
          />
        </Box>
        {children}
        <RecaptchaTerms />
      </Box>
    </Box>
  );
};
